import { h } from 'preact'

import Modal from '../../components/reactModal'
import Button from '../ui-components/Button'
import Logo from '../assets/logo'

interface Props { username: string, email:string, communityName: string, termsConditions: string, clientId: string, csrfToken: string}

const Authorize = ({ username, email, communityName, termsConditions, clientId, csrfToken }: Props) => {
  const zapierApp = 'Zapier'
  return (
    <Modal className='authorization-modal' isOpen>
      <h3 className='authorization-modal_title'><span
        className='authorization-modal_client-app-name'> {zapierApp} </span> wants to access
                your {communityName} account</h3>
      <div className='authorization-modal_message'>
        <div className='authorization-modal_logo'>
          <Logo width='150' height='50' customClass='authorization-modal_logo' />
        </div>
        <div className='authorization-modal_user-data'>
          <h6> This will allow <span className='authorization-modal_client-app-name'> {zapierApp} </span> to
                        access:</h6>
          <p>{email}</p>
          <p>{username}</p>
        </div>
        <div className='authorization-modal_additional-information'>
          <h6 style='font-weight:bold'> Make sure you trust <span
            className='authorization-modal_client-app-name'> {zapierApp} </span></h6>
          <p> Some more information on why you should make sure to trust {zapierApp}</p>
        </div>
      </div>
      <div className='authorization-modal_buttons'>
        <form action='/oauth/accessCode' method='POST'>
          <input type='hidden' name='client_id' value={clientId} />
          <input type='hidden' name='yip_csrf_token' value={csrfToken} />
          <Button
            primary
            type='submit'
            loading={false}
            disabled={false}
            style={{ width: '150px' }}
            title={'Authorize'}
          />
          <Button
            secondary
            loading={false}
            disabled={false}
            onClick={() => window.history.go(-1)}
            style={{ 'margin-left': '10px', width: '150px' }}
            title={'Cancel'}
          />
        </form>
      </div>
      <div className='authorization-modal_privacy-terms'>
        <a className='authorization-modal-terms-link' href={termsConditions}
          target='_blank'> {communityName} privacy policy</a>
      </div>
    </Modal>
  )
}

export default Authorize
